<template>
  <div class="manufacturer-sheet pa-10 pt-0">

    <tab-navigation
        :title="$t('manufacturer.manufacturer')"
        icon="mdi-factory"
        :breadcrumbs="breadcrumbs"
    >
      <v-tabs>
        <v-tab :to="{name: 'manufacturer'}" exact>{{ $t('manufacturer.sections.product-lines') }}</v-tab>
        <v-tab :to="{name: 'manufacturer.firmware'}">{{ $t('manufacturer.sections.firmware') }}</v-tab>
        <v-tab v-if="canConfigure" :to="{name: 'manufacturer.configuration'}">{{ $t('manufacturer.sections.configuration') }}</v-tab>
        <v-tab :to="{name: 'manufacturer.settings'}">{{ $t('manufacturer.sections.settings') }}</v-tab>
        <v-tab :to="{name: 'manufacturer.history'}">{{ $t('manufacturer.sections.history') }}</v-tab>
      </v-tabs>
    </tab-navigation>

    <router-view v-if="sheet"></router-view>

  </div>
</template>

<script>
import ManufacturerRepository from "@repository/ManufacturerRepository";
import FirmwareMixin from "@pages/Firmware/FirmwareMixin";
import TabNavigation from "@blocks/TabNavigation.vue";

// Les anciennes adresses (?section=…) ouvrent l'onglet correspondant.
const SECTIONS = {'product-lines': 'manufacturer', models: 'manufacturer', firmware: 'manufacturer.firmware', configuration: 'manufacturer.configuration', settings: 'manufacturer.settings', history: 'manufacturer.history'}

/**
 * La fiche d'un constructeur, comme les autres fiches : un onglet par sujet, chacun à son adresse. Ses gammes et ses
 * types d'abord, puis le firmware, les clés de configuration suivies, les réglages (nom, marques annoncées, transfert)
 * et l'historique. Les onglets lisent la fiche chargée ici (`$parent.sheet`) et la rechargent par `load()`.
 */
export default {
  components: {TabNavigation},
  mixins: [FirmwareMixin],

  props: {
    id: {type: String, required: true},
  },

  data() {
    return {
      sheet: null,
    }
  },

  computed: {
    // Les clés de configuration suivies : l'équipe ZEborne qui règle les bornes.
    canConfigure() {
      return this.isFirmwareOperator && this.hasFirmwarePermission('STATION_CONFIGURATION')
    },
    breadcrumbs() {
      const breadcrumbs = [{text: this.$t('manufacturer.title'), to: {name: 'manufacturers'}, exact: true}]
      if (this.sheet) {
        breadcrumbs.push({text: this.sheet.name})
      }
      return breadcrumbs
    },
  },

  watch: {
    id() {
      this.sheet = null
      this.load()
    },
  },

  mounted() {
    const section = SECTIONS[this.$route.query.section]
    if (section) {
      this.$router.replace({name: section, params: {id: this.id}})
    }
    this.load()
  },

  methods: {
    load() {
      return ManufacturerRepository.get(this.id).then(sheet => {
        this.sheet = sheet
      }).catch(err => {
        this.notifyError(err)
      })
    },
  },
}
</script>
